import * as angular from "angular";
import {PdfFormTemplateModel} from "../models/pdf-form-template.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {IQService} from "angular";

export class PdfFormTemplatesRequestsService {

  /* @ngInject */
  constructor(private PdfFormTemplatesAPI, private $pdfFormTemplates, private Upload,
              private splitService: SplitService, private apiConfig: ApiConfig, private $q: IQService) {
  }

  getList() {
    const api = this.PdfFormTemplatesAPI.actions.getList;
    return this.$$call(api, {}, {}, {});
  }

  getOne(id: string) {
    const api = this.PdfFormTemplatesAPI.actions.getOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  createOne(pdfFormTemplate: PdfFormTemplateModel) {
    const api = this.PdfFormTemplatesAPI.actions.createOne;
    return this.$$call(api, {}, pdfFormTemplate, {});
  }

  uploadOne(file) {
    const siteId = this.splitService.getSiteId();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/pdfFormTemplates/uploadForm`,
      method: 'PUT',
      params: {siteId: siteId},
      data: {file: file}
    })
      .then((response) => {
        return this.$q.when(response.data);
      })
  }

  updateOne(id: string, pdfFormTemplate: PdfFormTemplateModel) {
    const api = this.PdfFormTemplatesAPI.actions.updateOne;
    return this.$$call(api, {}, pdfFormTemplate, {id: id});
  }

  deleteOne(id: string) {
    const api = this.PdfFormTemplatesAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$pdfFormTemplates().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.document-management')
  .service('pdfFormTemplatesRequestsService', PdfFormTemplatesRequestsService);
